import { HEADING_STYLES as e } from "../../../constants/default-styles.mjs";
import { TextLevelEnum as t } from "../text-level-enum.mjs";
import { jsx as n } from "react/jsx-runtime";
//#region src/extensions/heading-extension/utils/text-level.tsx
var r = (r) => {
	let i = (e) => {
		switch (e) {
			case t.Default:
			default: return r("text_level.paragraph");
			case t.H2: return r("text_level.header_one");
			case t.H3: return r("text_level.header_two");
			case t.H4: return r("text_level.header_three");
		}
	};
	return [
		{
			value: t.Default,
			label: i(t.Default),
			customLabel: /* @__PURE__ */ n("div", { children: i(t.Default) })
		},
		{
			value: t.H2,
			label: i(t.H2),
			customLabel: /* @__PURE__ */ n("div", {
				style: { fontSize: e[t.H2]?.fontSize },
				className: "font-bold",
				children: i(t.H2)
			})
		},
		{
			value: t.H3,
			label: i(t.H3),
			customLabel: /* @__PURE__ */ n("div", {
				style: { fontSize: e[t.H3]?.fontSize },
				className: "font-bold",
				children: i(t.H3)
			})
		},
		{
			value: t.H4,
			label: i(t.H4),
			customLabel: /* @__PURE__ */ n("div", {
				style: { fontSize: e[t.H4]?.fontSize },
				className: "font-semibold",
				children: i(t.H4)
			})
		}
	];
}, i = (e) => {
	if (!e) return;
	let n = e.getAttributes("heading");
	if (n.level) switch (n.level) {
		case 2: return t.H2;
		case 3: return t.H3;
		case 4: return t.H4;
	}
	return t.Default;
};
//#endregion
export { i as getCurrentTextLevelValue, r as getTextLevelValues };
